import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import {AngularEditorConfig} from '@kolkov/angular-editor';

import { MustMatch } from '../../_helpers/must-match.validator';
import { AlertService, MerchantService } from '../../_services';
import { Utils } from '../../_helpers';

@Component({templateUrl: 'merchant.add.html'})
export class MerchantAdd implements OnInit {
    heading = 'Add Merchant';
    subheading = '';
    icon = 'fa fa-simplybuilt icon-gradient bg-happy-itmeo';
    merchantForm: FormGroup;
    loading = false;
    submitted = false;
    merchant_logo = null;
    preview_merchant_logo = null;

    wyswigconfig: AngularEditorConfig = {
      editable: true,
      spellcheck: true,
      height: '15rem',
      minHeight: '5rem',
      placeholder: 'Enter text here...',
      translate: 'no',
      customClasses: [
        {
          name: 'quote',
          class: 'quote',
        },
        {
          name: 'redText',
          class: 'redText'
        },
        {
          name: 'titleText',
          class: 'titleText',
          tag: 'h1',
        },
      ]
    };

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private merchantService: MerchantService,
        private alertService: AlertService
    ) { }

    ngOnInit() {
        this.merchantForm = this.formBuilder.group({
            merchant_name: ['', [Validators.required, Utils.noWhitespaceValidator]],
            merchant_description: ['', Validators.required],
            merchant_logo: ['', [Validators.required, Utils.noWhitespaceValidator]],
            merchant_email: ['', [Validators.required, Utils.noWhitespaceValidator, Validators.pattern('[a-zA-Z0-9.-]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')]],
            merchant_password: ['', [Validators.required, Utils.noWhitespaceValidator,Validators.min(6)]],
            merchant_confirm_password: ['', [Validators.required, Utils.noWhitespaceValidator, Validators.min(6)]],
            merchant_status: ['', [Validators.required, Utils.noWhitespaceValidator]]
        }, {
            validator: MustMatch('merchant_password', 'merchant_confirm_password')
        });
    }

    // convenience getter for easy access to form fields
    get f() { return this.merchantForm.controls; }

    IconChange(files: FileList) {
        this.merchant_logo = files[0];
        this.merchantForm.get('merchant_logo').setValue(this.merchant_logo.name);
        var reader = new FileReader();
        reader.readAsDataURL(this.merchant_logo); 
        reader.onload = (_event) => { 
          this.preview_merchant_logo = reader.result; 
        }
    }

    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.merchantForm.invalid) {
            return;
        }

        this.loading = true;

        const formData = new FormData();
        formData.append('merchant_name', this.merchantForm.get('merchant_name').value);
        formData.append('merchant_description', this.merchantForm.get('merchant_description').value);
        formData.append('merchant_logo', this.merchant_logo, this.merchant_logo.name);
        formData.append('merchant_email', this.merchantForm.get('merchant_email').value);
        formData.append('merchant_password', this.merchantForm.get('merchant_password').value);
        formData.append('merchant_status', this.merchantForm.get('merchant_status').value);

        this.merchantService.insert(formData).pipe(first()).subscribe((data: any) => {
              if(data.status=='ok') {
                this.alertService.success(data.message, true);
                this.router.navigate(['/merchant']);
              } else {
                this.alertService.error(data.message, true);
              }
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            }
        );
    }
}